// Actions
import { createAction } from "redux-actions";
import types from "./types";

export default {
  addContactDetails: createAction(types.ADD_CONTACT_DETAILS),
  addContactDetailsSuccess: createAction(types.ADD_CONTACT_DETAILS_SUCCESS),
  addContactDetailsFail: createAction(types.ADD_CONTACT_DETAILS_FAILED),
};
